// extracted by mini-css-extract-plugin
export default {"mainContainer":"productList_mainContainer__M417-","container":"productList_container__P8tQo","cardContainer":"productList_cardContainer__uV6HE"};